export enum StatusValues {
  success = 'success',
  processing = 'processing',
  error = 'error'
}